var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.22731 6.40763C8.6879 6.71735 7.27359 7.34976 8.135 8.14112C8.55579 8.52769 9.02445 8.80416 9.61366 8.80416H12.9758C13.565 8.80416 14.0337 8.52769 14.4545 8.14112C15.3159 7.34976 13.9016 6.71735 13.3622 6.40763C12.0972 5.68134 10.4922 5.68134 9.22731 6.40763Z",
    stroke: "#676767",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7655 2.43144C12.7655 3.24364 12.107 3.90207 11.2948 3.90207C10.4826 3.90207 9.82422 3.24364 9.82422 2.43144C9.82422 1.61924 10.4826 0.960815 11.2948 0.960815C12.107 0.960815 12.7655 1.61924 12.7655 2.43144Z",
    stroke: "#676767",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6023 18.1726C15.0629 18.4824 13.6486 19.1148 14.51 19.9061C14.9308 20.2927 15.3994 20.5692 15.9887 20.5692H19.3508C19.94 20.5692 20.4087 20.2927 20.8295 19.9061C21.6909 19.1148 20.2766 18.4824 19.7372 18.1726C18.4722 17.4464 16.8672 17.4464 15.6023 18.1726Z",
    stroke: "#676767",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1405 14.1965C19.1405 15.0087 18.482 15.6671 17.6698 15.6671C16.8576 15.6671 16.1992 15.0087 16.1992 14.1965C16.1992 13.3843 16.8576 12.7258 17.6698 12.7258C18.482 12.7258 19.1405 13.3843 19.1405 14.1965Z",
    stroke: "#676767",
    strokeWidth: 1.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85622 18.1726C2.31681 18.4824 0.902497 19.1148 1.76391 19.9061C2.1847 20.2927 2.65335 20.5692 3.24256 20.5692H6.60473C7.19394 20.5692 7.66259 20.2927 8.08339 19.9061C8.9448 19.1148 7.53049 18.4824 6.99107 18.1726C5.72615 17.4464 4.12114 17.4464 2.85622 18.1726Z",
    stroke: "#676767",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39438 14.1965C6.39438 15.0087 5.73595 15.6671 4.92375 15.6671C4.11155 15.6671 3.45312 15.0087 3.45312 14.1965C3.45312 13.3843 4.11155 12.7258 4.92375 12.7258C5.73595 12.7258 6.39438 13.3843 6.39438 14.1965Z",
    stroke: "#676767",
    strokeWidth: 1.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2948 11.7454V14.1965M11.2948 14.1965L13.7458 15.6671M11.2948 14.1965L8.84375 15.6671",
    stroke: "#676767",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrm);
export default __webpack_public_path__ + "static/media/Crm.81ed46d298edc2cc1ead42f0b3fa51d9.svg";
export { ForwardRef as ReactComponent };